import script from "./CarViver.vue?vue&type=script&setup=true&lang=js"
export * from "./CarViver.vue?vue&type=script&setup=true&lang=js"

import "./CarViver.vue?vue&type=style&index=0&id=1c47bed5&lang=css"

const __exports__ = script;

export default __exports__